import React from 'react'

export const Checked = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="white" />
    <rect x="3" y="3" width="10" height="10" rx="1" fill="#5CB5FE" />
  </svg>
)
